import { CollapseAllIcon } from './CollapseAllIcon';

/**
 * author: Michael Irigoyen
 * id C66052C9-BB2A-4E5F-A890-C6D8156E5621
 * name collapse-all
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/collapse-all.svg
 * tags
 */
export const AnimationMinusIcon = CollapseAllIcon;
export default AnimationMinusIcon